module.exports = __webpack_public_path__ + "static/media/boxes.632554eb.png";